export const getImageFromProductByVariant = (product: GQL.IProduct, variant: GQL.IProductVariant) => {
    const images = product.images && product.images.sort((a: any, b: any) => {
        return a.priority > b.priority
            ? 1
            : -1;
    });

    return images && images[0];
};



// WEBPACK FOOTER //
// ./src/helpers/getImageFromProductByVariant.ts